<template>
  <span @click="toggleInfoDialog()" style="cursor:pointer">
    <md-icon class="info-icon" :class="{small:size=='small'}">help_outline</md-icon>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Info</md-dialog-title>
      <md-dialog-content>
        <p class="moow-info-txt">{{infoContent}}</p>
      </md-dialog-content>
    </md-dialog>
  </span>
</template>
<script>
export default {
  props: {
    infoContent: {
      type: String,
      required: false
    },
    size:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    toggleInfoDialog() {
      this.showDialog = true;
    }
  }
};
</script>
<style scoped>
@import "../../../assets/styles/global.css";

.info-icon.small{
  font-size: 15pt !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interface/buttons/infoToggle.vue